import { render } from "./TherapyList.vue?vue&type=template&id=c5b1c658&ts=true"
import script from "./TherapyList.vue?vue&type=script&lang=ts"
export * from "./TherapyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/TherapyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5b1c658"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5b1c658', __exports__)) {
    api.reload('c5b1c658', __exports__)
  }
  
  module.hot.accept("./TherapyList.vue?vue&type=template&id=c5b1c658&ts=true", () => {
    api.rerender('c5b1c658', render)
  })

}


export default __exports__